import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

import { formatAgentRequestLabel } from "../../../DailyView/utils/formatAgentRequestLabel";

interface QualificationPickerProps {
  qualifications: string[];
  selectedQualification: string;
  onChange: (qualification: string) => void;
}

/**
 * Lets the user pick which of the worker's qualifications to invite them as,
 * when the worker holds multiple qualifications that match the workplace.
 *
 * Matches the visual style of the time slot picker in ShiftDateAndSlotPicker.
 */
export function QualificationPicker(props: QualificationPickerProps) {
  const { qualifications, selectedQualification, onChange } = props;

  return (
    <Box>
      <Text
        semibold
        sx={(theme) => ({ color: theme.palette.base?.base, marginBottom: 2 })}
        variant="body2"
      >
        Invite as
      </Text>
      <Stack direction="row" flexWrap="wrap" gap={2} role="radiogroup">
        {qualifications.map((qualification) => {
          const isSelected = qualification === selectedQualification;
          const label = formatAgentRequestLabel(qualification);

          return (
            <Box
              key={qualification}
              aria-checked={isSelected}
              aria-label={label}
              role="radio"
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingX: 3,
                paddingY: 2,
                borderRadius: theme.borderRadius?.medium,
                border: `1px solid ${isSelected ? theme.palette.base?.primary : theme.palette.border?.base}`,
                backgroundColor: isSelected ? `${theme.palette.base?.primary}08` : "transparent",
                cursor: "pointer",
                "&:hover": {
                  borderColor: theme.palette.base?.primary,
                },
              })}
              tabIndex={0}
              onClick={() => {
                onChange(qualification);
              }}
              onKeyDown={(event: React.KeyboardEvent) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onChange(qualification);
                }
              }}
            >
              <Text semibold sx={(theme) => ({ color: theme.palette.base?.base })} variant="body2">
                {label}
              </Text>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
